import React from 'react'

import Author from '../../../components/Author'
import { fetchAuthorData } from '../../../data/server/query-transform/fetchAuthorData'

const AuthorsPreview = ({ stories, author, params, metadata }) => (
  <Author storiesData={stories} author={author} params={params} metadata={metadata} />
)

export async function getServerSideProps(context) {
  return await fetchAuthorData({ context, isPreview: true })
}

export default AuthorsPreview
